const fallbackText = {
    available: 'tilgjengelig',
    is: 'er',
    are: 'er',
    result: 'resultat',
    results: 'resultater',
    of: 'av',
    highlighted: 'markert',
};
function selectedOption(option, index, length, textObject) {
    const text = textObject || fallbackText;
    return `${option} ${index + 1} ${text.of} ${length} ${text.is} ${text.highlighted}`;
}
function availableOptions(length, textObject) {
    const text = textObject || fallbackText;
    const wordIs = length === 1 ? text.is : text.are;
    const wordResult = length === 1 ? text.result : text.results;
    return `${length} ${wordResult} ${wordIs} ${text.available}.`;
}
export const addStatusText = {
    selectedOption,
    availableOptions,
};
//# sourceMappingURL=statusText.js.map